import { useEffect, useState } from "react";

export default function useSectionDarkMode(anchor = "top") {
  const [darkMode, setDarkMode] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;

    const DARK_IDS = new Set(["about", "solutions2", "partners"]);
    const SECTION_IDS = [
      "about",
      "solutions",
      "solutions2",
      "apps",
      "ecosystem",
      "partners",
      "contact",
    ];

    const readSections = () =>
      SECTION_IDS.map((id) => {
        const el = document.getElementById(id);
        if (!el) return null;
        const rect = el.getBoundingClientRect();
        const top = rect.top + window.scrollY;
        const height = el.offsetHeight || rect.height || 0;
        return { id, top, bottom: top + height };
      }).filter(Boolean);

    let sections = readSections();
    let currentIndex = -1;

    const getAnchorY = () =>
      anchor === "bottom"
        ? window.scrollY + window.innerHeight
        : window.scrollY;

    const locateIndex = (y) => {
      if (!sections.length) return -1;
      if (y < sections[0].top) return -1;
      return sections.findIndex((s) => y >= s.top && y < s.bottom);
    };

    const updateMode = () => {
      const y = getAnchorY();
      const idx = locateIndex(y);
      if (idx !== currentIndex) {
        currentIndex = idx;
        setDarkMode(idx !== -1 && DARK_IDS.has(sections[idx]?.id));
      }
    };

    updateMode();

    window.addEventListener("scroll", updateMode, { passive: true });
    window.addEventListener("resize", () => {
      sections = readSections();
      updateMode();
    });

    return () => {
      window.removeEventListener("scroll", updateMode);
      window.removeEventListener("resize", updateMode);
    };
  }, [anchor]);

  return darkMode;
}
